(function(){
  var root=document.querySelector('[data-sv]');if(!root)return;
  var form=root.querySelector('[data-sv-form]'),num=root.querySelector('[data-sv-num]'),sel=root.querySelector('[data-sv-carrier]'),
      err=root.querySelector('[data-sv-err]'),res=root.querySelector('[data-sv-result]');
  var C={
    colissimo:{n:'Colissimo',u:function(c){return 'https://www.laposte.fr/outils/suivre-vos-envois?code='+c}},
    laposte:{n:'La Poste',u:function(c){return 'https://www.laposte.fr/outils/suivre-vos-envois?code='+c}},
    chronopost:{n:'Chronopost',u:function(c){return 'https://www.chronopost.fr/tracking-no-cms/suivi-page?listeNumerosLT='+c}},
    '17track':{n:'17TRACK (international)',u:function(c){return 'https://t.17track.net/fr#nums='+c}}
  };
  function detect(c){
    if(/TS$/.test(c)||/^(XP|XW|XY|XZ|CH)\d{9}/.test(c))return 'chronopost';
    if(/^[0-9][A-Z0-9]\d{9,11}$/.test(c))return 'colissimo';
    if(/^[A-Z]{2}\d{9}FR$/.test(c))return 'laposte';
    if(/^[A-Z]{2}\d{9}[A-Z]{2}$/.test(c))return '17track';
    if(/^\d{13}$/.test(c))return 'chronopost';
    return 'laposte';
  }
  function fromCompany(s){s=(s||'').toLowerCase();return s.indexOf('chrono')>-1?'chronopost':s.indexOf('colissimo')>-1?'colissimo':s.indexOf('poste')>-1?'laposte':null}
  function show(code,k,auto){
    var c=C[k],url=c.u(encodeURIComponent(code));
    root.querySelector('[data-sv-badge]').textContent=c.n;
    root.querySelector('[data-sv-code]').textContent=code;
    root.querySelector('[data-sv-msg]').textContent=(auto?'Transporteur détecté : ':'Transporteur : ')+c.n+'. Le suivi officiel s\'ouvre dans un nouvel onglet avec ton numéro déjà rempli.';
    var o=root.querySelector('[data-sv-open]');o.href=url;o.textContent='Ouvrir le suivi '+c.n+' ↗';
    root.querySelector('[data-sv-links]').innerHTML=Object.keys(C).filter(function(x){return x!==k}).map(function(x){return '<a target="_blank" rel="noopener" href="'+C[x].u(encodeURIComponent(code))+'">'+C[x].n+'</a>'}).join('');
    res.hidden=false;res.scrollIntoView({behavior:'smooth',block:'nearest'});
  }
  function go(code,forced){
    code=(code||'').replace(/\s+/g,'').toUpperCase();
    if(code.length<8||/[^A-Z0-9-]/.test(code)){err.hidden=false;res.hidden=true;return}
    err.hidden=true;var v=forced||sel.value,auto=v==='auto';
    show(code,auto?detect(code):v,auto);
  }
  form.addEventListener('submit',function(e){e.preventDefault();go(num.value)});
  root.querySelectorAll('[data-sv-fill]').forEach(function(b){b.addEventListener('click',function(){num.value=b.dataset.svFill;go(num.value,fromCompany(b.dataset.svCompany))})});
  var q=new URLSearchParams(location.search).get('num');if(q){num.value=q;go(q)}
})();
